import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../../Field';

class PensionProviderReferenceRequest extends Component {
    constructor(props) {
        super(props);
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    getChildInputComponents() {
        let inputComponents = [];
        inputComponents = inputComponents.concat(this.inputComponents);
        this.childComponents.filter(component => {
            return (component !== null) && (component !== undefined);
        }).map(component => {
            inputComponents = inputComponents.concat(component.getChildInputComponents());
        });

        return inputComponents;
    }

    render() {
        return (
            <div>
                <Field
                    type={'money'}
                    fieldName={'annualIncome'}
                    question={'Please enter the Gross Pension received by the applicant'}
                    storageKey={'annualIncome'}
                    source={this.props.source}
                    dataValidation={'2_decimal_money'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'refereeName'}
                    type={'text'}
                    question={'Your name/position'}
                    storageKey={'refereeName'}
                    source={this.props.source}
                    maxLength={60}
                    dataValidation={'alpha_and_space_only'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
            </div>
        );
    }
}

PensionProviderReferenceRequest.propTypes = {
    source: PropTypes.string.isRequired,
};

export default PensionProviderReferenceRequest;


// WEBPACK FOOTER //
// ./src/components/Screens/ReferenceRequest/PensionProvider.js